export interface IUserPreferences {
  weeklySummaryEmailNotification?: boolean
  meVsMeSmsNotification?: boolean
  meVsMarketSmsNotification?: boolean
  missingDataSmsNotification?: boolean
  hiddenServiceCategories?: string[]
}
